/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('scroll-carousel').forEach(carousel => {
//     const dots = carousel.parentElement.querySelectorAll('.carousel-dot');
//     if (!dots.length) return;

//     // When clicking a dot â†’ scroll to that slide
//     dots.forEach((dot, index) => {
//       dot.addEventListener('click', () => {
//         carousel.scrollToCell(index); // theme built-in scroll method
//         dots.forEach(d => d.classList.remove('is-selected'));
//         dot.classList.add('is-selected');
//       });
//     });

//     // When carousel changes â†’ update active dot
//     carousel.addEventListener('select', e => {
//       const selected = e.detail?.index || 0;
//       dots.forEach((dot, i) =>
//         dot.classList.toggle('is-selected', i === selected)
//       );
//     });
//   });
// });




document.addEventListener("DOMContentLoaded", function () {
  const galleryImages = document.querySelectorAll(
    ".product-gallery__carousel img"
  );

  galleryImages.forEach((image) => {
    if (image.alt === "hide_multi") {
      // Find the closest container with the group class and remove it
      const mediaGroup = image.closest(".product-gallery__media");
      if (mediaGroup) {
        mediaGroup.remove();
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var copyButtons = document.querySelectorAll(".code");
  var discountCodes = document.querySelectorAll(".offer_coupon strong");

  copyButtons.forEach(function (button, index) {
    button.addEventListener("click", function () {
      // Copy discount code to clipboard
      navigator.clipboard
        .writeText(discountCodes[index].innerText)
        .then(function () {
          // Change button text to "Text Copied" when copied
          button.innerText = "Text Copied";
        })
        .catch(function (error) {
          console.error("Unable to copy discount code: ", error);
        });
    });
  });
});

$(".slick-carousel").slick({
  arrows: false,
  centerPadding: "0px",
  dots: true,
  slidesToShow: 1,
  infinite: false,
});

$(".slick-carousel_review").slick({
  arrows: true,
  centerPadding: "0px",
  dots: false,
  autoplay: true,
  autoplayspeed: 2000,
  slidesToShow: 1,
  infinite: false,
  responsive: [
    {
      breakpoint: 1199.99,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        arrows: false,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

$(".about_our_vision").slick({
  arrows: true,
  dots: false,
  slidesToShow: 1,
  infinite: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        arrows: false,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

$(".collection_section_wrap").slick({
  dots: true,
  arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 1199.99,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
        arrows: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

$(".shop_by_category_wrapper").slick({
  arrows: true,
  centerPadding: "0px",
  dots: false,
  slidesToShow: 1,
  infinite: false,
  responsive: [
    {
      breakpoint: 9999,
      settings: "unslick",
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

function toggleOffers() {
  var offers = document.querySelectorAll(".offers_section .offers"); // Select all offers
  var toggleIcon = document.querySelector(".toggle_icon svg");

  // Determine current state based on the first offer block
  var isHidden =
    offers[0].style.display === "none" || offers[0].style.display === "";

  // Toggle the state for all offers
  offers.forEach(function (offer) {
    if (isHidden) {
      offer.style.display = "block"; // Show offers
    } else {
      offer.style.display = "none"; // Hide offers
    }
  });

  // Update the toggle icon based on the new state
  if (isHidden) {
    // Switch to "hide" icon
    toggleIcon.outerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="7" viewBox="0 0 13 7" fill="none"><path d="M1.89454 5.77412L6.64037 1.22626C6.74393 1.12651 6.88265 1.07164 7.02642 1.07355C7.1702 1.07547 7.30741 1.13402 7.40827 1.2365L12.0312 5.90827C12.1327 6.01071 12.2703 6.06918 12.4145 6.0711C12.5587 6.07302 12.6979 6.01824 12.8021 5.91855C12.8534 5.86986 12.8944 5.81139 12.9227 5.74659C12.9511 5.68179 12.9662 5.61197 12.9671 5.54124C12.9681 5.47052 12.9549 5.40032 12.9282 5.33479C12.9016 5.26925 12.8622 5.20971 12.8122 5.15967L8.19028 0.487905C7.88584 0.180911 7.47306 0.00568243 7.04074 -8.18163e-05C6.60842 -0.00584606 6.19111 0.158314 5.8786 0.457082L1.13378 5.00395C1.08232 5.05266 1.04116 5.11119 1.01272 5.17608C0.984276 5.24098 0.969136 5.31091 0.968191 5.38176C0.967247 5.4526 0.980517 5.52292 1.00722 5.58854C1.03392 5.65417 1.07351 5.71378 1.12364 5.76384C1.22514 5.86627 1.3628 5.92475 1.50699 5.92667C1.65118 5.92859 1.79035 5.87381 1.89454 5.77412Z" fill="black"/></svg>';
  } else {
    // Switch to "show" icon
    toggleIcon.outerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none"><path d="M11.0685 0.157702L6.38373 4.76843C6.28151 4.86955 6.14353 4.92627 5.99974 4.92627C5.85596 4.92627 5.71798 4.86955 5.61576 4.76843L0.930984 0.158703C0.828133 0.0576334 0.689701 0.0010004 0.545502 0.0010004C0.401302 0.0010004 0.262871 0.0576334 0.16002 0.158703C0.109374 0.208077 0.0691233 0.267089 0.0416412 0.332263C0.0141592 0.397436 0 0.467451 0 0.538181C0 0.608911 0.0141592 0.678925 0.0416412 0.744098C0.0691233 0.809271 0.109374 0.868283 0.16002 0.917657L4.8438 5.52738C5.15231 5.83029 5.56739 6 5.99974 6C6.4321 6 6.84718 5.83029 7.15569 5.52738L11.8395 0.917657C11.8903 0.868268 11.9306 0.809194 11.9582 0.743928C11.9858 0.678663 12 0.608531 12 0.53768C12 0.466829 11.9858 0.396698 11.9582 0.331433C11.9306 0.266167 11.8903 0.207092 11.8395 0.157702C11.7366 0.056633 11.5982 0 11.454 0C11.3098 0 11.1714 0.056633 11.0685 0.157702Z" fill="black"/></svg>';
  }
}

// Initially hide the offers sections
document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".offers_section .offers")
    .forEach(function (offer) {
      offer.style.display = "block"; // Hide all offers initially
    });
});



/* =========================================================================
   FS product-card enhancements (v2):
   1) Move the existing add-to-cart form to the bottom of the card info as a
      full-width "ADD TO CART" button.
   2) When a colour swatch is chosen:
        a) show that colour's main product image on the card (the big image),
           found via product media tagged with alt "#Color_<COLOUR>".
        b) set the ADD TO CART form to the FIRST AVAILABLE variant of that colour.
   Data comes from /products/{handle}.js (fetched once per card and cached).
   ========================================================================= */
(function () {
  function toHttps(u) { return u && u.indexOf("//") === 0 ? "https:" + u : u; }
  function withWidth(u, w) {
    if (!u) return u;
    if (/[?&]width=/.test(u)) return u;
    return u + (u.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
  }
  // "#Color_ROSE" -> "rose"
  function colorOf(alt) { return alt ? alt.replace(/#?color[_\s-]*/i, "").trim().toLowerCase() : ""; }

  function getProductData(card) {
    if (card.__fsProdPromise) return card.__fsProdPromise;
    var handle = card.getAttribute("handle");
    if (!handle) { card.__fsProdPromise = Promise.resolve(null); return card.__fsProdPromise; }
    card.__fsProdPromise = fetch("/products/" + encodeURIComponent(handle) + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return card.__fsProdPromise;
  }

  function colorOptionIndex(product) {
    var opts = product.options || [];
    for (var i = 0; i < opts.length; i++) {
      var name = typeof opts[i] === "string" ? opts[i] : (opts[i] && opts[i].name);
      if (name && String(name).toLowerCase() === "color") return i;
    }
    return opts.length ? opts.length - 1 : 0;
  }

  function applyColor(card, color) {
    if (!color) return;
    var key = String(color).toLowerCase();
    getProductData(card).then(function (p) {
      if (!p) return;

      // (a) main image = first product media tagged with this colour
      var main = card.querySelector(".product-card__image--primary");
      if (main && p.media) {
        for (var i = 0; i < p.media.length; i++) {
          var a = p.media[i].alt || "";
          if (a.toLowerCase().indexOf("hide_multi") === -1 && colorOf(a) === key && p.media[i].src) {
            main.setAttribute("src", withWidth(toHttps(p.media[i].src), 600));
            main.removeAttribute("srcset");
            break;
          }
        }
      }

      // (b) ADD TO CART = first available variant of this colour
      if (p.variants) {
        var idx = colorOptionIndex(p);
        var chosen = null, fallback = null;
        for (var j = 0; j < p.variants.length; j++) {
          var vr = p.variants[j];
          var vColor = vr.options && vr.options[idx] != null ? String(vr.options[idx]).toLowerCase() : "";
          if (vColor === key) {
            if (!fallback) fallback = vr;
            if (vr.available) { chosen = vr; break; }
          }
        }
        chosen = chosen || fallback;
        if (chosen) {
          var idInput = card.querySelector('form.product__btn_custom [name="id"]');
          if (idInput) idInput.value = chosen.id;
        }
      }
    });
  }

  function initCard(card) {
    if (card.__fsCardInit) return;
    card.__fsCardInit = true;

    var info = card.querySelector(".product-card__info");
    var atc = card.querySelector("form.product__btn_custom.desktop_btn");
    if (info && atc) {
      var submit = atc.querySelector('[name="add"]');
      if (submit && !submit.value) submit.value = "ADD TO CART";
      atc.classList.add("fs-atc-btn");
      info.appendChild(atc); // move below the swatches
    }

    // preload product data on first interaction so the swatch click is instant
    var pre = function () {
      getProductData(card);
      card.removeEventListener("mouseenter", pre);
      card.removeEventListener("touchstart", pre);
    };
    card.addEventListener("mouseenter", pre);
    card.addEventListener("touchstart", pre, { passive: true });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(".product-card").forEach(initCard);
  }

  document.addEventListener("change", function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('.variant-picker__option-values input[type="radio"]')) return;
    var card = input.closest(".product-card");
    if (!card) return;
    applyColor(card, input.value);
  });

  document.addEventListener("DOMContentLoaded", function () {
    initAll();
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType !== 1) continue;
          if (n.classList && n.classList.contains("product-card")) initCard(n);
          else if (n.querySelectorAll) initAll(n);
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  });

  initAll();
})();


/* =========================================================================
   FS Corner cart-drawer image fix:
   The "Corner" cart app shows each line item's VARIANT image, which for these
   products is the small "hide_multi" swatch close-up. Replace it with that
   colour's real product image (media tagged alt "#Color_<COLOUR>").
   Corner re-renders (Lit), so we watch for its line items and re-apply.
   ========================================================================= */
(function () {
  var cartMap = null; // variant_id -> { handle, color }
  var prodCache = {};

  function colorOf(alt) { return alt ? alt.replace(/#?color[_\s-]*/i, "").trim().toLowerCase() : ""; }
  function toHttps(u) { return u && u.indexOf("//") === 0 ? "https:" + u : u; }
  function withWidth(u, w) {
    if (!u) return u;
    if (/[?&]width=/.test(u)) return u;
    return u + (u.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
  }

  function loadCart() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var map = {};
        (c.items || []).forEach(function (it) {
          var color = "";
          (it.options_with_values || []).forEach(function (o) {
            if (String(o.name).toLowerCase() === "color") color = o.value;
          });
          map[String(it.variant_id)] = { handle: it.handle, color: color };
        });
        cartMap = map;
        return map;
      })
      .catch(function () { cartMap = cartMap || {}; return cartMap; });
  }

  function getProd(handle) {
    if (!handle) return Promise.resolve(null);
    if (prodCache[handle]) return prodCache[handle];
    prodCache[handle] = fetch("/products/" + encodeURIComponent(handle) + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return prodCache[handle];
  }

  function fixItem(el) {
    var vid = el.getAttribute("data-corner-variant-id");
    if (!vid || !cartMap) return;
    var info = cartMap[String(vid)];
    if (!info || !info.color) return;
    getProd(info.handle).then(function (p) {
      if (!p || !p.media) return;
      var key = info.color.toLowerCase(), src = null;
      for (var i = 0; i < p.media.length; i++) {
        var a = p.media[i].alt || "";
        if (a.toLowerCase().indexOf("hide_multi") === -1 && colorOf(a) === key && p.media[i].src) { src = p.media[i].src; break; }
      }
      if (!src) return;
      src = withWidth(toHttps(src), 200);
      var img = el.querySelector('img[data-testid="item-image"]') || el.querySelector("img");
      if (img && img.getAttribute("src") !== src) { img.setAttribute("src", src); img.removeAttribute("srcset"); }
    });
  }

  function fixAll() { document.querySelectorAll("[data-corner-variant-id]").forEach(fixItem); }

  var timer = null;
  function schedule() { if (timer) clearTimeout(timer); timer = setTimeout(function () { loadCart().then(fixAll); }, 150); }

  function start() {
    if (!document.body) return;
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if ((n.hasAttribute && n.hasAttribute("data-corner-variant-id")) ||
              (n.querySelector && n.querySelector("[data-corner-variant-id]"))) { schedule(); return; }
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
    if (document.querySelector("[data-corner-variant-id]")) schedule();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();



/* Boost horizontal filter: keep dropdown visible with single-row scroll */
(function(){
  function place(){
    document.querySelectorAll('.boost-sd__filter-option--horizontal').forEach(function(opt){
      var wrap=opt.querySelector('.boost-sd__filter-option-itemwrapper');
      var title=opt.querySelector('.boost-sd__filter-option-title');
      if(!wrap||!title){ return; }
      if(wrap.classList.contains('boost-sd__filter-option-itemwrapper--hidden')){ wrap.style.position=''; wrap.style.top=''; wrap.style.left=''; return; }
      var r=title.getBoundingClientRect();
      var w=wrap.offsetWidth||240;
      var left=r.left; if(left+w>window.innerWidth-8){ left=window.innerWidth-w-8; } if(left<8){ left=8; }
      wrap.style.position='fixed'; wrap.style.top=(r.bottom+6)+'px'; wrap.style.left=left+'px'; wrap.style.zIndex='9999';
    });
  }
  document.addEventListener('click', function(){ setTimeout(place,20); }, true);
  window.addEventListener('scroll', place, true);
  window.addEventListener('resize', place);
})();
